import { jsx as _jsx } from "react/jsx-runtime";
import { ElementChip } from "./base/ElementChip";
import { ValueIcon } from "./valueIcons/ValueIcon";
import { AI_INTEREST_ICON, findValueIcon, INTEREST_FALLBACK_ICON, INTEREST_ICONS } from "./valueIcons/valueIconMaps";
var ICON_SX = { fontSize: 18, color: "secondary.main" };
/** The AI mark on AI-found interests, else the value's own icon, else the interest icon. */
export function InterestIcon(_a) {
    var _b;
    var value = _a.value, _c = _a.aiGenerated, aiGenerated = _c === void 0 ? false : _c;
    var spec = aiGenerated ? AI_INTEREST_ICON : ((_b = findValueIcon(INTEREST_ICONS, value)) !== null && _b !== void 0 ? _b : INTEREST_FALLBACK_ICON);
    return _jsx(ValueIcon, { glyph: spec.glyph, off: spec.off, sx: ICON_SX });
}
export function InterestElement(_a) {
    var label = _a.label, value = _a.value, _b = _a.aiGenerated, aiGenerated = _b === void 0 ? false : _b, _c = _a.active, active = _c === void 0 ? false : _c, onClick = _a.onClick, onDelete = _a.onDelete;
    if (!label)
        return null;
    return (_jsx(ElementChip, { text: label, startIcon: _jsx(InterestIcon, { value: value, aiGenerated: aiGenerated }), active: active, onClick: onClick, onDelete: onDelete }));
}
